import "core-js/modules/es.array.splice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    conditions: {
      type: Object
    },
    gradeData: {
      type: Array
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      data: [],
      form: {
        computeType: 1
      }
    };
  },
  mounted: function mounted() {
    if (this.conditions) {
      this.data = this.conditions.data;

      for (var key in this.form) {
        this.form[key] = this.conditions[key];
      }
    }
  },
  methods: {
    clickDelete: function clickDelete(index, row) {
      var tmp = this.$tempModel.deepCopy(this.data);
      tmp.splice(index, 1);
      this.data = tmp;
    },
    clickAddCond: function clickAddCond() {
      this.data.push({
        grade: '',
        pv: '',
        rate: ''
      });
    },
    clickAddAllCond: function clickAddAllCond() {
      for (var i = 0; i < this.gradeData.length; i++) {
        var item = this.gradeData[i];
        this.data.push({
          grade: item.tag,
          rate: 0
        });
      }
    },
    getParams: function getParams() {
      var params = this.form;
      params.data = this.data;
      return this.$tempModel.deepCopy(params);
    }
  }
};